import { RootState } from "@lxp-app/store/store";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import UserRole from "@lxp-app/utils/roles";

// Route config: each route has multiple allowed roles
export const authoringRoutes = [
  {
    path: "question-paper-authoring",
    roles: [UserRole.ASSESSMENT_CREATOR],
    tab: 4
  },
  {
    path: "assessment-authoring",
    roles: [UserRole.ASSESSMENT_ADMIN],
    tab: 5
  }
];

export const superAdminRoutes = [
  {
    path: "user-group-authoring",
    roles: [UserRole.USER_GROUP_CREATOR],
    tab: 0
  },
  {
    path: "manage-role-dashboard",
    roles: [UserRole.ROLE_ADMIN],
    tab: 1
  }
];

export const ContentAuthoringRedirect = ({ routes = authoringRoutes }) => {
  const userRoles = useSelector(
    (state: RootState) => state.UserInfoSlice.profile.role
  );

  const allowedRoute = routes.find((route) =>
    route.roles.some((role) => userRoles.includes(role))
  );

  if (!allowedRoute) {
    return <Navigate to="/error/forbidden" />;
  }

  return <Navigate to={`/authoring/${allowedRoute.path}`} replace />;
};

export const SuperAdminRedirect = () => {
  const userRoles = useSelector(
    (state: RootState) => state.UserInfoSlice.profile.role
  );

  const allowedRoute = superAdminRoutes.find((route) =>
    route.roles.some((role) => userRoles.includes(role))
  );

  if (!allowedRoute) {
    return <Navigate to="/error/forbidden" />;
  }

  return <Navigate to={`/super-admin/${allowedRoute.path}`} replace />;
};

export const getAllowedAuthoringRoutes = () => {
  const userRoles = useSelector(
    (state: RootState) => state.UserInfoSlice.profile.role
  );
  return authoringRoutes
    .filter((route) => route.roles.some((role) => userRoles?.includes(role)))
    .map((route, index) => ({
      ...route,
      tab: index
    }));
};

export const getAllowedSuperAdminRoutes = () => {
  const userRoles = useSelector(
    (state: RootState) => state.UserInfoSlice.profile.role
  );
  return superAdminRoutes
    .filter((route) => route.roles.some((role) => userRoles?.includes(role)))
    .map((route, index) => ({
      ...route,
      tab: index
    }));
};
